import OutlookLogo from '../assets/images/outlook-logo.svg';
import TeamsLogo from '../assets/images/teams-logo.svg';
import SlackLogo from '../assets/images/slack-logo.svg';

export const vendorDict = {
    "SaaS Vendor": "saas",
    "BCR": "bcr",
    "BFR": "bfr",
    "EFR": "efr",
    "EMR": "emr",
    "ODR": "odr",
    "RFC": "rfc",
    "On-Prem DB": "dbpswd",
    "Microsoft 365": "365",
    "Firewall/Security Exception": "fwexc",
    "AWS Health":"awshealth",
    "Venafi Certificates":"vc",
    "RMA":"rma"
};

export const sourceMapping = {
    "saas vendor": "SaaS Vendor",
    "bcr": "Business Critical",
    "bfr": "Business Flexible",
    "efr": "Enterprise Flexible",
    "emr": "Enterprise Maintenance",
    "odr": "On Demand",
    "rfc": "RFC",
    "on-prem db": "On-Prem DB",
    "microsoft 365": "Microsoft 365",
    "firewall/security exception": "Firewall/Security Exception",
    "aws health":"AWS Health",
    "venafi certificates":"Venafi Certificates",
    "rma":"RMA"
}

export const eventTypes = [
    "Firewall/Security Exception",
    "On-Prem DB",
    "AWS Health",
    "Venafi Certificates",
    "RFC"
  ];

export const sourceGroupMap = {
    "saas vendor": { group: "Vendor Events", type: "Release" },
    "bcr": { group: "Enterprise Releases", type: "Release" },
    "bfr": { group: "Enterprise Releases", type: "Release" },
    "efr": { group: "Enterprise Releases", type: "Release" },
    "emr": { group: "Enterprise Releases", type: "Release" },
    "odr": { group: "Enterprise Releases", type: "Release" },
    "rfc": { group: "Enterprise Releases", type: "Event" },
    "firewall/security exception": { group: "Infrastructure Updates", type: "Event" },
    "on-prem db": { group: "Infrastructure Updates", type: "Event" },
    "aws health": { group: "Vendor Events", type: "Event" },
    "microsoft 365": { group: "Vendor Events", type: "Release" },
    "venafi certificates": { group: "Infrastructure Updates", type: "Event" },
    "rma": { group: "Infrastructure Updates", type: "Event" },
    };

export const CUSTOM_SAP_SERVICES = ['SAP-S4 Hana', 'SAP - CPI', 'SAP-MBC'];

export const Notification_Platforms = {
    "outlook": { title: "Outlook (Default)", logo: OutlookLogo, isActive: true },
    "slack": { title: "Slack", logo: SlackLogo, isActive: true },
    "teams": { title: "Teams", logo: TeamsLogo, isActive: false }
};
